<template>
  <div class="photo-container">
    <!-- Overlay de carga -->
    <div v-if="overlayVisible" :class="['loading-overlay', { fadeout: overlayFadeOut }]">
      <!-- Logo en esquina superior izquierda (idéntico al del componente principal) -->
      <div class="overlay-top-left-logo">
        <img src="@/assets/logonav.png" alt="Logo esquina" />
      </div>

      <!-- Logo centrado -->
      <div class="overlay-center-logo">
        <img src="@/assets/logonav.png" alt="Logo central" />
      </div>
    </div>

    <!-- Logos parte superior -->
    <div class="header-logos">
      <img src="@/assets/logonav.png" alt="HP y Real Madrid" />
    </div>

    <!-- NUEVO: botón superior para cambiar cámara -->
    <button
      class="switch-camera-button top-switch-button"
      @click="switchCamera"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free v6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path d="M213.1 64.8L202.7 96 128 96c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L426.9 64.8C420.4 45.2 402.1 32 381.4 32L258.6 32c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16l-76.7 0c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3l0 76.7zM192 320c0-8.8 7.2-16 16-16l76.7 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3l0-76.7z"/></svg>
    </button>
    <!-- FIN NUEVO -->

    <!-- MODAL -->
    <div v-if="modalVisible" class="full-modal">
      <div class="modal-header">
        <div class="header-logos">
          <img src="@/assets/logonav.png" alt="HP y Real Madrid" />
        </div>

        <h2>Escoge tu estilo favorito</h2>
      </div>

      <div class="styles-container">
        <div
          v-for="modelo in modelosTerminados"
          :key="modelo.id"
          class="style-card"
          :class="{ selected: selectedModel?.id === modelo.id }"
          @click="seleccionarModelo(modelo)"
        >
          <img :src="modelo.imagen_url" alt="Imagen del modelo" />
          <p>{{ modelo.nombre_terminado }}</p>
        </div>
      </div>

      <div class="modal-actions">
        <button class="back-btn d-none" @click="modalVisible = false">Regresar</button>
        <button class="next-btn d-none" :disabled="!selectedModel" @click="cerrarModal">Avanzar</button>
      </div>
    </div>

    <!-- Vista de Cámara / Foto -->
    <div class="camera-box">
      <div v-if="cameraActive" class="video-wrapper">
        <video ref="video" autoplay playsinline></video>
        <!-- <button class="capture-button" @click="takePicture">Foto</button> -->
        <!-- <button class="switch-camera-button" @click="switchCamera">Cambiar Cámara</button> -->
        <img class="overlay-frame" src="@/assets/pleca.png" alt="Marco decorativo" />
      </div>

      <div v-if="previewActive" class="preview-container">
        <img :src="imagePreview" alt="Preview" class="preview-image" />
        <img class="overlay-frame" src="@/assets/pleca.png" alt="Marco decorativo" />
      </div>
    </div>

    <!-- Texto y botón "Tomar foto" -->
    <div
      class="take-photo-btn"
      v-if="!previewActive && !modalVisible"
      @click="takePicture"
    >
      Tomar foto
    </div>

    <div class="left-text">
      <!-- Texto opcional -->
      <!-- Colócate en el marco<br />y saca el jugador<br />que llevas dentro -->
    </div>

    <div class="right-text" v-if="previewActive">
      <!-- CAMBIO: bloqueo y texto dinámico -->
      <button
        class="confirm-button"
        :disabled="sending"
        @click="sendImage"
      >
        {{ sending ? 'Enviando…' : '¡Me gusta!' }}
      </button>

      <button class="retake-button" @click="retakePicture">
        Repetir foto
      </button>
    </div>
  </div>
</template>


  <script>
import axios from "axios";

export default {
  data() {
    return {
      cameraActive: false,
      previewActive: false,
      videoStream: null,
      imagePreview: null,
      capturedImageBlob: null,
      devices: [], // Lista de cámaras disponibles
      currentDeviceIndex: 0, // Índice de la cámara actual
      modelosTerminados: [],
      selectedModel: null,
      modalVisible: true,
      overlayVisible: true, // nuevo
      overlayFadeOut: false, // nuevo

      // NUEVO: evitar múltiples envíos
      sending: false,
    };
  },
  async mounted() {
    try {
      await Promise.all([this.cargarModelosTerminados(), this.openCamera()]);

      // Cuando ambos procesos estén listos:
      this.overlayFadeOut = true;

      // Esperar que termine la transición (0.5s) antes de ocultar
      setTimeout(() => {
        this.overlayVisible = false;
      }, 500);
    } catch (error) {
      console.error("Error inicializando el componente:", error);
    }
  },

  methods: {
    async cargarModelosTerminados() {
      try {
        const response = await axios.get("/api/modelos-terminados", {});
        if (response.data.success) {
          this.modelosTerminados = response.data.data;
        }
      } catch (error) {
        console.error("Error al cargar los modelos terminados:", error);
      }
    },

    seleccionarModelo(modelo) {
      this.selectedModel = {
        id: modelo.id,
        nombre: modelo.nombre_terminado,
        imagenUrl: modelo.imagen_url,
      };

      console.log("Modelo seleccionado:", this.selectedModel);

      // Cerrar el modal después de seleccionar el modelo
      this.modalVisible = false;
    },

    cerrarModal() {
      this.modalVisible = false;
    },

    async getCameras() {
      const devices = await navigator.mediaDevices.enumerateDevices();
      this.devices = devices.filter((device) => device.kind === "videoinput");

      if (this.devices.length === 0) {
        alert("No se detectaron cámaras disponibles.");
      }
    },

    async openCamera() {
      await this.getCameras();

      if (this.devices.length === 0) {
        console.warn("No hay cámaras disponibles.");
        return;
      }

      // Seleccionar la cámara por prioridad
      const preferredCamera = this.devices.find((device) =>
        device.label.includes("HP 320 FHD Webcam")
      );
      const fallbackCamera = this.devices.find((device) =>
        device.label.includes("HP")
      );

      let deviceToUse;
      if (preferredCamera) {
        deviceToUse = preferredCamera.deviceId;
      } else if (fallbackCamera) {
        deviceToUse = fallbackCamera.deviceId;
      } else {
        deviceToUse = this.devices[0].deviceId; // Usar la primera cámara si no hay ninguna HP
      }

      // Mantener currentDeviceIndex alineado con la cámara usada
      const index = this.devices.findIndex(
        (d) => d.deviceId === deviceToUse
      );
      this.currentDeviceIndex = index >= 0 ? index : 0;

      await this.startCamera(deviceToUse);
    },

    async startCamera(deviceId) {
      try {
        // Verificar si los permisos de la cámara han sido concedidos anteriormente
        const permissions = await navigator.permissions.query({
          name: "camera",
        });

        if (permissions.state === "denied") {
          alert(
            "Los permisos de la cámara están bloqueados. Habilítalos en la configuración del navegador."
          );
          return;
        }

        // Solicitar acceso a la cámara con los constraints
        const constraints = {
          video: {
            deviceId: deviceId ? { exact: deviceId } : undefined,
            facingMode: "environment",
          },
        };

        this.videoStream = await navigator.mediaDevices.getUserMedia(
          constraints
        );
        this.cameraActive = true;

        // Asignar la transmisión de video al elemento <video>
        this.$nextTick(() => {
          if (this.$refs.video) {
            this.$refs.video.srcObject = this.videoStream;
            this.$refs.video.style.transform = "scaleX(-1)"; // Asegura que no haya modo espejo
          }
        });

        // Guardar el dispositivo actual en el store
        this.$store.commit("setSelectedCameraId", deviceId);
      } catch (error) {
        console.error("Error al abrir la cámara:", error);

        // Manejo de errores por tipos
        if (error.name === "NotAllowedError") {
          alert(
            "Permisos de la cámara denegados. Asegúrate de habilitarlos."
          );
        } else if (error.name === "NotFoundError") {
          alert(
            "No se encontró una cámara disponible en tu dispositivo."
          );
        } else if (error.name === "OverconstrainedError") {
          alert(
            "No se puede acceder a la cámara con las restricciones actuales. Prueba con otra cámara."
          );
        } else {
          alert(
            "No se pudo abrir la cámara. Intenta de nuevo o verifica los permisos."
          );
        }
      }
    },

    // AJUSTADO: soporta 0, 1 o varias cámaras
    async switchCamera() {
      if (this.devices.length === 0) {
        alert("No se detectaron cámaras disponibles.");
        return;
      }

      // Detener la cámara actual
      if (this.videoStream) {
        this.videoStream.getTracks().forEach((track) => track.stop());
      }

      if (this.devices.length === 1) {
        // Solo una cámara: "cambiar" de [0] a [0] (reiniciar)
        this.currentDeviceIndex = 0;
        const onlyDeviceId = this.devices[0].deviceId;
        await this.startCamera(onlyDeviceId);
        return;
      }

      // Cambiar al siguiente dispositivo (cuando hay más de una)
      this.currentDeviceIndex =
        (this.currentDeviceIndex + 1) % this.devices.length;
      const nextDeviceId = this.devices[this.currentDeviceIndex].deviceId;

      await this.startCamera(nextDeviceId);
    },

    closeCamera() {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach((track) => track.stop());
        this.videoStream = null;
      }
      this.cameraActive = false;
    },

    takePicture() {
      const video = this.$refs.video;
      const canvas = document.createElement("canvas");

      // Dimensiones calculadas para la captura
      const canvasWidth = 624; // Ancho (90% del ancho en proporción áurea)
      const canvasHeight = 837; // Alto (87% del alto de la pantalla)

      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      const context = canvas.getContext("2d");

      // Calcula el área a recortar del video
      const videoAspectRatio = video.videoWidth / video.videoHeight;
      let sx = 0,
        sy = 0,
        sw = video.videoWidth,
        sh = video.videoHeight;

      if (videoAspectRatio > 1) {
        // Video más ancho que alto, recortar horizontalmente
        sw = (video.videoHeight * canvasWidth) / canvasHeight;
        sx = (video.videoWidth - sw) / 2;
      } else {
        // Video más alto que ancho, recortar verticalmente
        sh = (video.videoWidth * canvasHeight) / canvasWidth;
        sy = (video.videoHeight - sh) / 2;
      }

      // Dibuja el video en el canvas con las dimensiones calculadas
      context.drawImage(
        video,
        sx,
        sy,
        sw,
        sh,
        0,
        0,
        canvasWidth,
        canvasHeight
      );

      // Convertir el canvas a un blob
      canvas.toBlob(
        (blob) => {
          this.capturedImageBlob = blob;
          this.imagePreview = URL.createObjectURL(blob);
          this.previewActive = true;
          this.cameraActive = false;
        },
        "image/jpeg",
        1
      );
    },

    retakePicture() {
      this.previewActive = false;
      this.imagePreview = null;
      this.openCamera();
    },

    async sendImage() {
      // NUEVO: evitar doble click / peticiones múltiples
      if (this.sending) return;

      if (!this.capturedImageBlob) {
        alert("No hay imagen para enviar.");
        return;
      }

      this.sending = true;

      // Convertir blob a base64
      const base64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result.replace(
            /^data:image\/png;base64,/,
            ""
          );
          resolve(base64data);
        };
        reader.readAsDataURL(this.capturedImageBlob);
      });

      try {
        await axios.post("/api/guardar-imagen-pendiente", {
          clave_pendiente: this.$store.state.tokens.clavePendiente,
          token_final: this.$store.state.tokens.tokenFinal,
          modelo_id: this.selectedModel.id,
          imagen_base64: base64,
          v2: true
        });

        // Redirige inmediatamente al video
        this.$router.push("/video");
      } catch (error) {
        console.error("Error al enviar la imagen:", error);
        alert("No se pudo guardar la imagen. Intenta de nuevo.");
      } finally {
        // Si hay error, se vuelve a habilitar el botón.
        // Si todo sale bien, el componente se desmonta al cambiar de ruta.
        this.sending = false;
      }
    },
  },
};
</script>

  
  <style lang="scss" scoped>
  .camera-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // height: 100vh;
    min-height: 100%;
    width: 100%;
    /* background: #f0f0f0;  */
    // padding: 20px;
  }
  
  .camera-screen {
    position: relative;
    width: 100%;
  }
  
  .video-wrapper {
    width: 100%; /* Relativo al ancho de la pantalla */
    height: 100%; /* Relativo al alto de la pantalla */
    aspect-ratio: 477 / 716; /* Relación áurea */
    overflow: hidden;
    border-radius: 10px;
    border: 2px solid #ccc;
    
    video {
      width: 100%;
      height: 100%;
      object-fit: cover; /* Evita deformaciones */
      transform: scaleX(-1);
    }
    
  }
  .overlay-frame {
    position: absolute;
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    // height: 100%;
    pointer-events: none; // evita que bloquee los clics
    z-index: 5;
  }


  // .close-camera-button,
  // .confirm-button,
  // .retake-button {
  //   background-color: #007bff;
  //   color: #fff;
  //   border: none;
  //   padding: 10px 20px;
  //   margin: 10px;
  //   border-radius: 5px;
  //   cursor: pointer;
  // }
  .capture-button {
    background: #3dffbe;
    color: #fff;
    border: none;
    padding: 1vw 2vw 1vw 4vw;
    font-weight: bold;
    border-radius: 5px;
    position: absolute;
    // z-index: 1;
    height: 6vw;
    font-size: 3vw;
    top: 0;
    bottom: 0;
    right: 0;
    left: auto;
    margin:  auto;
  }
  .confirm-button,.retake-button {
    border-top: 1px solid white;
    
  }
  .switch-camera-button, .confirm-button, .retake-button {
    background: transparent;
    border-bottom: 1px solid white;
    color: white;
    padding: 0.8vw 2vw;
    font-size: 2.5vw;
    max-width: 16vw;
    // border-radius: 25px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: white;
      color: #0095d9;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  
  // .capture-button:hover,
  // .close-camera-button:hover,
  // .confirm-button:hover,
  // .retake-button:hover {
  //   background-color: #26b988;
  // }
  
  .preview-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;
  }
  
  .preview-image {
    width: 100%;
    // max-width: ;;
    object-fit: cover;
    border: 2px solid #ccc;
    border-radius: 10px;
    transform: scaleX(-1);
    // margin-bottom: 20px;
  }


  /* estilos para template */

  

.hero-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  width: 100%;
  font-family: 'FormaDJRDisplay', sans-serif;
  padding: 20px;
  box-sizing: border-box;
}

.cta-section {
  display: flex;
  justify-content: center;
  width: 100%;
  flex-wrap: nowrap;
  
}

.cont-cam {
  width: 60vw;
  aspect-ratio: 624 / 837; /* Relación áurea */
  display: flex;
  align-items: center;
  // margin-top: 1vh;
  margin-bottom: 3vh;
  position: relative;
  background: #fff;
  padding: 0;

  /* Esquinas superiores */
  // &::before,
  // &::after {
  //   content: "";
  //   position: absolute;
  //   width: 7vw;
  //   height: 7vw;
  //   border: 0.4vw solid black;
  //   z-index: 2;
  // }

  // &::before {
  //   top: 0;
  //   left: 0;
  //   border-bottom: none;
  //   border-right: none;
  // }

  // &::after {
  //   top: 0;
  //   right: 0;
  //   border-bottom: none;
  //   border-left: none;
  // }

  // /* Esquinas inferiores usando divs adicionales */
  // .corner-i {
  //   position: absolute;
  //   width: 7vw;
  //   height: 7vw;
  //   border: 0.4vw solid black;
  //   bottom: 0;
  //   left: 0;
  //   border-top: none;
  //   border-right: none;
  //   z-index: 2;
  // }
  
  // .corner-d {
  //   z-index: 2;
  //   position: absolute;
  //   width: 7vw;
  //   height: 7vw;
  //   border: 0.4vw solid black;
  //   bottom: 0;
  //   right: 0;
  //   border-top: none;
  //   border-left: none;
  // }
}



.cta-box {
  display: flex;
  align-items: center;
  background: #dfdddd;
  padding: 2vw;
  border-radius: 1vw;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 90%;
  // height: ;
  // max-width: 500px;
  flex-wrap: wrap;
  margin-bottom: 20%;
  .hp-logo {
    width: 4vw;
    height: auto;
    margin-right: 1vw;
  }
  .white{
    width: 100%;
    background: #fff;
    padding: 1.5vw 2vw;
    border-radius: 1vw;
    margin-top: 1.5vw;
    display: flex;
    align-items: center;
    // p {
    //   font-size: 5vw;
    //   text-align: left;
    //   line-height: 1;
    // }
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .card {
      width: 45%;
      cursor: pointer!important;
      background: #ecececdd;
      padding: 1vw;
      margin: 1vw;
      img {
        margin: 0 auto;
      }
      p {
        font-size: 3vw;
      }
    }
  }
  .cta-text {
      flex: 1;
      font-size: 16px;
      color:#b3b3b3;
    }

  .cta-button {
    cursor: pointer;
    border-radius: 5px;
    transition: background 0.3s;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin: 0;
  
    width: 100%;
    height: auto;
    max-width: 6vw;
  }
}





// .cta-button:hover {
//   background: #00a56b;
// }

.logos-section {
  margin-top: 4vw;
  display: flex;
  align-items: center;
  width: 90vw;
  // height: 10vh;
  span {
    font-size: 3vw;
    // font-weight: bold;
    margin: 0 3vw;
  }
  img {
    width: 7vw;

  }
  // .logos-image {
  //   width: 4vw;
  //   height: auto;
  // }
  
}

.tipo-foto {
  position: absolute;
  z-index: 1;
  width: 100%;
  // height: ;
}

.full-modal {
  position: fixed;
  inset: 0;
  background: linear-gradient(to right, #48465c 0%, #211f2e 50%, #151d2b 100%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2vw;
  font-family: 'FormaDJRDisplay', sans-serif;
  color: white;
  height: 100%;
  
  h2 {
    position: absolute;
    top: 20vh;
    bottom: auto;
    left: 0;
    right: 0;
    margin: auto;
  }
  
}

.modal-header {
  text-align: center;
  margin-bottom: 2vh;
  .logo {
    width: 140px;
  }
  .partner-label {
    font-size: 0.9rem;
    margin-top: 0.5rem;
  }
  h2 {
    margin-top: 2vh;
    font-size: 2rem;
  }
}

.styles-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 2vw;
  width: 100%;
  margin-top: 2vh;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;

  .style-card {
    // background-color: white;
    margin-top: 6%;
    padding: 1vw;
    border-radius: 8px;
    width: 23vw;
    text-align: center;
    cursor: pointer;
    color: black;
    transition: transform 0.3s ease, border 0.3s ease;
     p {
      margin-top: 20px;
      color: #fff;
      font-size: 3vw;
      padding: 10px 0;
      border-top: 1px solid #fff;
      border-bottom: 1px solid #fff;

      transition: all 0.2s;
      &:hover {
        background: #fff;
        color: #000;
      }
     }
    img {
      width: 100%;
      height: auto;
      border-radius: 4px;
    }

    &.selected {
      border: 3px solid #ffcc00;
      transform: scale(1.05);
    }
  }
}

.modal-actions {
  margin-top: 4vh;
  display: flex;
  gap: 2vw;

  button {
    background: transparent;
    border: 1px solid white;
    color: white;
    padding: 0.8vw 2vw;
    font-size: 1.2rem;
    // border-radius: 25px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: white;
      color: #0095d9;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
.photo-container {
  background: linear-gradient(to right, #48465c 0%, #211f2e 50%, #151d2b 100%);
  width: 100vw;
  height: 100vh;
  font-family: 'FormaDJRDisplay', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  color: white;
  overflow: hidden;
}

.header-logos {
  position: absolute;
  top: 2vh;
  left: 2vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 40vw;
    max-width: 45vw;
  }
  .tech-partner {
    font-size: 0.9rem;
    margin-top: 0.5rem;
    text-align: center;
  }
}

.camera-box {
  width: 60vw;
  aspect-ratio: 624 / 837; /* Relación áurea */
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 5rem;
  border-radius: 10px;
  overflow: hidden;

  .video-wrapper {
    width: 100%;
    height: 100%;
    position: relative;

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transform: scaleX(-1);
    }

    .capture-button {
      position: absolute;
      bottom: 10px;
      left: 10px;
      background-color: #3dffbe;
      color: white;
      padding: 0.5rem 1rem;
      border: none;
      border-radius: 5px;
      font-weight: bold;
      cursor: pointer;
    }

    .switch-camera-button {
      position: absolute;
      bottom: 10px;
      right: 10px;
      background-color: #3dffbe;
      color: white;
      padding: 0.5rem 1rem;
      border: none;
      border-radius: 5px;
      font-weight: bold;
      cursor: pointer;
    }
  }
}

.preview-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  h2 {
    margin-bottom: 1rem;
  }
  img.preview-image {
    width: 100%;
    border-radius: 10px;
    transform: scaleX(-1);
    // margin-bottom: 1rem;
  }
}

.take-photo-btn {
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  font-size: 2.5vw;
  margin-top: 2vw;
  padding: 0.5vw 0;
  position: absolute;
  max-width: 16vw;
  left: 0;
  top: 20vh;
  right: 0;
  bottom: auto;
  margin: auto;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background: white;
    color: #0095d9;
  }
}

.left-text,
.right-text {
  position: absolute;
  font-size: 2vw;
  width: 30vw;
  text-align: left;
  line-height: 1.3;
}
.right-text {
  bottom: 4vh;
}

.left-text {
  top: 22vh;
  left: 66vw;
  font-size: 2em;
  font-weight: 300;
  letter-spacing: 2px;
}

.right-text {
  right: 2vw;
  text-align: right;
  display: flex;
  // flex-direction: column;
  // max-width: 300px;
  width: 95vw;
  flex-direction: row-reverse;
  justify-content: space-between;
}

.modal-header .logo {
  position: absolute;
    top: 2vh;
    left: 2vw;
    display: flex
;
    flex-direction: column;
    align-items: center;
}
.loading-overlay {
  position: fixed;
  inset: 0;
  background: linear-gradient(to right, #48465c 0%, #211f2e 50%, #151d2b 100%);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: opacity 0.5s ease;
  pointer-events: none;
}

.loading-overlay.fadeout {
  opacity: 0;
}

.overlay-top-left-logo {
  position: absolute;
  top: 2vh;
  left: 2vw;

  img {
    width: 40vw;
    max-width: 45vw;
  }
}

.overlay-center-logo {
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 40vw;
    max-width: 60vw;
  }
}




.tarjeta-preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  display: flex;
  justify-content: space-between;
  padding: 1rem 1.2rem;
  box-sizing: border-box;
  pointer-events: none;
  font-family: 'FormaDJRDisplay', sans-serif;
  color: #1a1a1a;
}

.info-izquierda {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  font-weight: bold;
  font-size: 1rem;
  text-align: left;

  .nombre {
    font-size: 1.5rem;
    font-weight: 500;
    min-height: 36px;
  }

  .apellido {
    font-size: 2rem;
    min-height: 48px;
  }
  
  .numero {
    font-size: 2.4rem;
    line-height: 1.2;
    min-height: 46px;
  }
}

.info-derecha {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  font-weight: bold;
  text-align: right;

  .posicion {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }

  .barra {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 0.8rem;
    // margin-bottom: 0.3rem;

    label {
      margin-bottom: 0.2rem;
    }

    progress {
      width: 120px;
      height: 8px;
      border-radius: 4px;
      overflow: hidden;
      background: #eee;

      &::-webkit-progress-bar {
        background-color: #eee;
        border-radius: 4px;
      }

      &::-webkit-progress-value {
        background-color: #3f51b5;
        border-radius: 4px;
      }

      &::-moz-progress-bar {
        background-color: #3f51b5;
      }
    }
  }
}
.d-none {
display: none!important;
}

/* Botón de cambiar cámara en la parte superior */
.top-switch-button {
  position: absolute;
  top: 2vh;
  right: 2vw;
  /* reutiliza la estética de .switch-camera-button ya definida */
  background: transparent;
  // border: 1px solid #fff;
  border: none;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  svg {
    fill: #ccc;
    min-height: 20px;
    transition: all 0.2s;
  }
}
.top-switch-button:hover{
  background: transparent;
  svg {
    transform: scale(1.1); 
  }
}
.top-switch-button:active{
  background: transparent;
  svg {
    transform: scale(0.9); 
  }
}
/* Opcional: un poco más claro cuando está deshabilitado el botón de enviar */
.confirm-button:disabled {
  opacity: 0.6;
  cursor: default;
}

  </style>
  